import React from 'react';
import cx from 'classnames';

import AnimateHeight from 'react-animate-height';

export default class Collapsible extends React.PureComponent {
  render() {
    const {open, trigger, duration, onTriggerClick, className, openedClassName, triggerClassName, contentOuterClassName, children} = this.props;

    return (
      <div className={open ? openedClassName : className}>
        <span className={triggerClassName} onClick={onTriggerClick}>{trigger}</span>
        <AnimateHeight
          duration={duration}
          height={open ? 'auto' : 0}
          className={contentOuterClassName}
        >
          {children}
        </AnimateHeight>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/collapsible/Collapsible.js